import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';

import {
  PatientAppointmentInventorySearch,
  PatientAppointmentInventorySearchVariables,
} from '@app/appointment/__generated__/patient-appointment-inventory-search-graphql.service.types';
import { ProviderOfficeResultFragment } from '@app/appointment/patient-appointment-inventory-search-graphql.fragments';

@Injectable()
export class PatientAppointmentInventorySearchGraphQL extends Query<
  PatientAppointmentInventorySearch,
  PatientAppointmentInventorySearchVariables
> {
  document = gql`
    query PatientAppointmentInventorySearch($input: PatientAppointmentInventorySearchInput!) {
      patientAppointmentInventorySearch(input: $input) {
        query
        providerCount
        inventoryCount
        firstAvailableInventoryDate
        results {
          ...ProviderOfficeResultFragment
        }
        recommendedRemoteResults {
          ...ProviderOfficeResultFragment
        }
        recommendedRemoteAppointmentType {
          id
          name
        }
      }
    }
    ${ProviderOfficeResultFragment}
  `;
}
